import { atomWithStorage } from 'jotai/utils';

const isLayoutMobileAtom = atomWithStorage('isLayoutMobile', false);

export { isLayoutMobileAtom };
export default isLayoutMobileAtom;
